"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _customerSource = require("@/api/customer-source");
var _vuexModuleDecorators = require("vuex-module-decorators");
var CustomerSourceStore = /*#__PURE__*/function (_VuexModule) {
  function CustomerSourceStore() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerSourceStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, CustomerSourceStore, [].concat(args));
    (0, _defineProperty2.default)(_this, "list", []);
    return _this;
  }
  (0, _inherits2.default)(CustomerSourceStore, _VuexModule);
  return (0, _createClass2.default)(CustomerSourceStore, [{
    key: "SET_LIST",
    value: function SET_LIST(list) {
      this.list = list;
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _customerSource.customerSourceApi.findAll();
            case 2:
              res = _context.sent;
              _context.next = 5;
              return this.context.commit('SET_LIST', res.data.customerSources);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
}(_vuexModuleDecorators.VuexModule);
(0, _tslib.__decorate)([_vuexModuleDecorators.Mutation], CustomerSourceStore.prototype, "SET_LIST", null);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], CustomerSourceStore.prototype, "fetchData", null);
CustomerSourceStore = (0, _tslib.__decorate)([(0, _vuexModuleDecorators.Module)({
  name: 'customerSource',
  namespaced: true
})], CustomerSourceStore);
var _default = exports.default = CustomerSourceStore;